export default __webpack_public_path__ + "static/media/TGA.7013f9cd.svg";